import React, {Component} from 'react'
import PropTypes from "prop-types";
import DatePicker from "react-datepicker";
import Error from "../single_components/Error";


class Self_Physiological_biometrics extends Component {

    constructor(props) {
        super(props);
        this.state = {
            entry: this.props.entry,
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.entry !== prevProps.entry) {
            this.setState({
                entry: this.props.entry
            })
        }
    }

    componentDidMount() {
    }

    render() {
        let {t} = this.props

        let maxLastTest=new Date()

        let minLastTest=new Date()
        minLastTest.setFullYear(maxLastTest.getFullYear()-10)

        let entry= this.state.entry
        let Last_test_date= entry.Last_test_date?new Date(entry.Last_test_date):""

        return (
            <div className={'patientsFormBoxes'}>
                <div className={'patientsFormRow'}>
                    <div className={'inputSlots'}>
                        <label className={'infoLabel'}> {t('patient_self_boarding.Weight')}</label>
                        <input  className={'inputBoxStyle'} type="number" name="Weight" value={entry.Weight_kg ? entry.Weight_kg: ""}
                                maxLength={3} min={30} max={999}
                                onChange={(event) => this.props.onValueChange("Weight_kg", event.target.value)}/>
                    </div>
                    <div className={'inputSlots'}>
                        <label className={'infoLabel'}>{t('patient_self_boarding.Height')}</label>
                        <input  className={'inputBoxStyle'} type="number"  name="Height" value={entry.Height_m}
                                maxLength={3} min={0} max={300}
                                onChange={(event) => this.props.onValueChange("Height_m", event.target.value)}/>
                    </div>


                </div>

            </div>

        )
    }
}

Self_Physiological_biometrics.propTypes = {
    onValueChange:PropTypes.func.isRequired,
    entry: PropTypes.object.isRequired,
    isDisabled: PropTypes.bool
}

export default Self_Physiological_biometrics;
